// 提交无效
import React, {useState, useRef, forwardRef, useImperativeHandle, useMemo, useEffect} from 'react';
import {Tabs, message, Radio, Form,} from 'antd';
import {SFuncModal, SGeneralForms} from 'shj-components';
import {callCenterInvValid, callInvValid} from "@/services/callCenter";
import {getBusinessDictList} from "@/services/product.ts";
import {get} from "lodash-es";

const SubmitInvalidDom: React.FC<any> = forwardRef(({ fn, onClose, ...rest }, ref) => {
  // const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [checkDiscardId, setCheckDiscardId] = useState<string | number>('');
  const [checkDiscardValue, setCheckDiscardValue] = useState('');
  const [checkDiscardCode, setCheckDiscardCode] = useState('');
  const [discardCauseList, setDiscardCauseList] = useState([]);

  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    getBusinessDictList({ data: { priKey: 'Zabandonreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      setDiscardCauseList(list)
    })
  }

  const handleSubmit = () => {
    const remark = form.getFieldValue('remark');
    if (!checkDiscardCode) return message.warning('请选择无效原因');
      const { id } = rest;
      rest.setLoading?.(true);
      const apiFn = rest.buttonKey === 'CALL_INVALID' ? callCenterInvValid : callInvValid
    apiFn({
        remark,
        reason: checkDiscardCode,
        reasonDesc: checkDiscardValue,
        clueId: id
      })
        .then((res: any) => {
          message.success(res?.data?.message || '操作成功');
          fn && fn();
          onClose && onClose();
        })
        .finally(() => {
          rest.setLoading?.(false);
        });
  };
  const items = useMemo(() => {
    setCheckDiscardId(discardCauseList[0]?.id)
    return discardCauseList.map((item => {
      return {
        label: item.label,
        key: item.id
      }
    }))
  }, [discardCauseList])

  const subItems = () => {
    const child = discardCauseList.find((e: any) => e.id == checkDiscardId)?.children || []
    return (
      <div>
        {child.map((d) => {
          return (
            <Radio.Button
              style={{ margin: '0 10px 10px 0', borderLeftWidth: '1px' }}
              key={d?.id} value={d?.object?.priKey} checked={checkDiscardCode === d?.object?.priKey} onClick={() => {
                setCheckDiscardValue(d.object?.name)
                setCheckDiscardCode(d?.object?.priKey)
              }}>{d?.label}</Radio.Button>
          );
        })}
      </div>
    )
  }
  const onReset=()=>{
    setCheckDiscardId(discardCauseList[0]?.id)
    setCheckDiscardCode('')
    setCheckDiscardValue('')
  }
  useImperativeHandle(
    ref,
    () => ({
      onFinish: handleSubmit,
      onReset,
    }),
    [handleSubmit],
  );
  return (
    <>
      <Tabs
        items={items}
        activeKey={checkDiscardId}
        onTabClick={(v: any) => {
          setCheckDiscardId(v)
          setCheckDiscardValue('')
          setCheckDiscardCode('')
        }}
      />
      <div style={{ padding: '20px 15px' }}>
        {subItems()}

        <SGeneralForms
            layout={'vertical'}
            formConfig={{form}}
            configs={[{
             formItem: [{
                spanCol: 24,
                label: '备注',
                name: 'remark',
                type: 'textarea',
                comConfig: {
                  maxLength: 200,
                  showCount: true,
                }
              }]
            }]}
        />

      </div>

    </>
  );
})
export function SubmitInvalidModalFn({ fn, ...rest }) {
  const destroy = () => {
    dialog.destroy();
  };
  const dialog: any = SFuncModal({
    title: '提交无效',
    width: 800,
    vanish: true,
    content: <SubmitInvalidFnDom fn={fn} onClose={destroy} {...rest} />,
  });
}
const SubmitInvalidFnDom: React.FC<any> = ({ fn, onClose, ...rest }) => {
  const addRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const onReset = () => {
    addRef?.current?.onReset();
  };
  return <SFuncModal.Content
    cancelText="取消"
    onCancel={() => { onClose?.(); }}
    onReset={onReset}
    onOk={() => {addRef?.current?.onFinish()}}
    confirmLoading={loading}
  >
    <SubmitInvalidDom ref={addRef} onClose={onClose} fn={fn} {...rest} setLoading={(loading) => setLoading(loading)} />
  </SFuncModal.Content>
}